import React from 'react';
type SectionProps = {
  id?: string;
  background: 'paper' | 'white' | 'forest';
  children: React.ReactNode;
  className?: string;
  labelledBy?: string;
  width?: 'content' | 'narrow';
};
const backgrounds = {
  paper: 'bg-paper text-ink',
  white: 'bg-white text-ink',
  forest: 'bg-forest text-white'
};
export function Section({
  id,
  background,
  children,
  className = '',
  labelledBy,
  width = 'content'
}: SectionProps) {
  return <section id={id} aria-labelledby={labelledBy} className={`w-full ${backgrounds[background]} ${className}`} data-id="element-243" data-mp="chrj8wg17zxa">
      <div className={`mx-auto px-5 sm:px-8 py-16 sm:py-24 lg:py-32 ${width === 'narrow' ? 'max-w-[720px]' : 'max-w-content'}`} data-id="element-244" data-mp="2qdf2bd4ybxt">
        {children}
      </div>
    </section>;
}
export function Kicker({
  children,
  tone = 'brass',
  className = ''
}: {
  children: React.ReactNode;
  tone?: 'brass' | 'sage';
  className?: string;
}) {
  return <p className={`font-sans text-[12px] font-semibold uppercase tracking-[0.14em] ${tone === 'brass' ? 'text-brass' : 'text-sage'} ${className}`} data-id="element-245" data-mp="2zkbzjpwr41qy">
      {children}
    </p>;
}
export function BrassRule() {
  return <div className="brass-rule mx-auto w-full max-w-content" role="presentation" data-id="element-246" data-mp="38doz3apbm1m0" />;
}